'use strict';

module.exports = heading;

var all = require('../all');

/* Transform a heading. */
function heading(h, node) {
  return h(node, 'h' + node.depth, all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/mdast-util-to-hast/lib/handlers/heading.js
// module id = 966
// module chunks = 0